import Vue from 'vue';
import CookieView from '../../../components/campaign/civicactioncenter/layout/CACCookieView.vue';
import store from '../../../stores/store';
import VueI18n from 'vue-i18n';
import translations from '../translations.js';

let generalFilters = require('../../../filters/general');
Vue.use(generalFilters);
Vue.use(VueI18n);

$(function() {
    const i18n = new VueI18n({
      locale: window.P2A.CivicActionCenter.language.toLowerCase(),
      messages: translations
    });

    new Vue({
        i18n,
        store,
        components: {
            CookieView
        }
    }).$mount('#top');
});
